
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let u = navigator.userAgent;
		let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
		let device= isAndroid?"H5_ANDROID":"H5_IOS"
		let APIS = {
			getImage: `/apis/moyin-real-voice-speaker/qrcodeImage/getImage?device=${device}`,
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"realVoiceCustomerPage"
			})
		}